import { render, staticRenderFns } from "./CMInsuranceTable.vue?vue&type=template&id=47cc00d4"
import script from "./CMInsuranceTable.vue?vue&type=script&lang=js"
export * from "./CMInsuranceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports